export default __webpack_public_path__ + "static/media/uploader-abbottXtra-problem-1.faffea1b.png";